// extracted by mini-css-extract-plugin
export default {"ourNewsItem":"ourNewsItem_ourNewsItem__nYL5N","txt":"ourNewsItem_txt__NZXMK","title":"ourNewsItem_title__whXRi","desc":"ourNewsItem_desc__tLfx3"};